export default () => ({
	openedIndex: 0,
	toggle(index) {
		this.openedIndex = this.openedIndex == index ? -1 : index;
	},
	isOpen(index) {
		return this.openedIndex === index;
	},
});
